/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc, doT, SCS */
	
	/**
	 * Module for Adobe Recommendations teaser component.
	 *
	 * @author Branislav Maksin
	 * @namespace Tc.Module
	 * @class RecommendationsTeaser
	 * @extends Tc.Module
	 */
	Tc.Module.RecommendationsTeaser = Tc.Module.extend({
		/**
		 * Hook function to do all of your module stuff.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx,
				$h2 = $('h2', $ctx);
			
			// Check if Recommendations title is empty
			if ($h2.is(':empty')) {
				$h2.hide();
			}

			callback();
		}
	});
})(Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/modules/Tc.Module.RecommendationsTeaser.js
// module id = 355
// module chunks = 0